import { Link } from "react-router-dom";
import { FileText, CaretLeft } from "@phosphor-icons/react";
import { NewsletterCard } from "../components/NewsletterCard";

export default function MarketingTemplatePage() {
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="marketing-template-page">
      <div className="mb-8 animate-fade-up">
        <Link to="/marketing/email" data-testid="back-to-email" className="inline-flex items-center gap-1 text-xs font-semibold text-white/50 hover:text-white transition-colors mb-4">
          <CaretLeft size={13} /> Email
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2 flex items-center gap-1.5">
          <FileText size={13} className="text-amber-400" /> Email — Template
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">Template</h1>
        <p className="text-sm text-slate-400 mt-3 max-w-2xl">Componi, salva come bozza, invia subito o programma le tue newsletter.</p>
      </div>
      <NewsletterCard />
    </main>
  );
}
